<template>
  <section class="loginForm_wrapper user wrapper soft">
    <img v-if="event.login_image_url" :src="event.login_image_url" alt="background" class="background_img" :class="event.theme_color" />
    <p v-if="preview" class="notice">※ログイン画面プレビュー（この画面からはログインできません）</p>
    <div class="loginForm_inner">
      <div class="loginForm_header">
        <h1>{{ event.name }}</h1>
        <p>開催日時 {{ $store.getters["event/formattedEventPeriod"] }}</p>
      </div>
      <div class="loginForm_body">
        <div class="form_title inner">
          <span class="">G-PLUS会員様ログイン</span>
        </div>
        <validation-observer ref="observer" v-slot="{handleSubmit, invalid}" class="form_body">
          <form @submit.prevent="handleSubmit(login)">
            <div v-if="message" class="error">
              <span style="color: #ff0000;">{{ message }}</span>
            </div>

            <validation-provider rules="required|email" v-slot="{errors}" name="メールアドレス" class="form-group">
              <div class="inner">
                <label for="email">メールアドレス</label>
                <input type="email" id="email" name="email" v-model="loginForm.email" />
                <div class="text-right">
                  <a class="text-link" target="_blank" :href="env === 'prod' ? 'https://service.yoshida-dental.co.jp/ac/register/gplus_temporary' : 'https://service-yoshida.valeur3.com/ac/register/gplus_temporary'">新規会員登録はこちら</a>
                </div>
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </div>
            </validation-provider>

            <validation-provider rules="required" v-slot="{errors}" name="パスワード" class="form-group">
              <div class="inner">
                <label for="password">パスワード</label>
                <input type="password" id="password" name="password" v-model="loginForm.password" />
                <div class="text-right">
                  <a class="text-link" target="_blank" :href="env === 'prod' ? 'https://service.yoshida-dental.co.jp/ac/password/forget' : 'https://service-yoshida.valeur3.com/ac/password/forget'">パスワードを忘れた方はこちら</a>
                </div>
                <ul v-if="errors.length">
                  <li v-for="(error, key) in errors" :key="key" style="color: #ff0000;">{{ error }}</li>
                </ul>
              </div>
            </validation-provider>

            <div class="button_area">
              <button class="btn" type="submit" :disabled="invalid">ログイン</button>
            </div>
          </form>
        </validation-observer>
      </div>
      <div class="login_guidance">
        <RawHtml :text="event.login_guidance" />
        <!--ToDo https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-590 イベント後、戻す-->
        <p v-if="!(Number(this.event.id) === Number(this.$config.app.noneLogoEventId))">
          当システムではビデオ会議ルームをご利用の際にはマイクの接続が必要です。お使いの機器にマイクが接続されていることをご確認ください。
        </p>
      </div>
      <div class="login_switch_page">
        <router-link tag="button" :to="preview ? '#' : {name: 'GuestLogin'}" class="btn">{{ event.can_self_registration_guest ? 'ゲスト利用の方、招待コードをお持ちの方はこちら' : '招待コードをお持ちの方はこちら' }}</router-link>
      </div>
    </div>
    <div class="loginForm_footer">
      <router-link :to="preview ? '#' : {name: 'AdminLogin'}">
        <span>管理者ログイン</span>
      </router-link>
    </div>
  </section>
</template>

<script>
import RawHtml from "../elements/RawHtml"

export default {
  name: "UserLogin",
  components: {RawHtml},
  props: {
    slug: {
      type: String,
      required: true
    },
    preview: {
      Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      env: process.env.MIX_APP_ENV
    }
  },
  computed: {
    event() {
      return this.$store.getters["event/event"]
    },
    message() {
      return this.$store.getters["auth/message"]
    }
  },
  mounted() {
    this.$store.commit("loading/setLoading", false)
  },
  methods: {
    login: async function() {
      if (this.preview) return

      this.$store.commit("loading/setLoading", true)
      await this.$store.dispatch("auth/login", {
        endpoint: `auth/${this.slug}/user/login`,
        inputs: this.loginForm,
        validationObserver: this.$refs.observer,
        slug: this.slug
      })
    }
  }
}
</script>

<style scoped>
  .text-right {
    text-align: right;
  }
  
  .form-group .inner .text-link {
    display: inline-block;
    margin: 4px 0 8px;
  }
</style>
